import React, { useState, Fragment, useRef } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    GoogleMap,
    LoadScript,
    Marker,
    InfoWindow,
    InfoBox
} from '@react-google-maps/api';

import {
    makeStyles,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    Typography,
    colors,
    Link,
    Box,
    Avatar,
    Icon
} from '@material-ui/core';

import { RiAlarmWarningFill } from "react-icons/ri";

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    container: {
        maxHeight: 500
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));


const divStyle = {
    background: `white`,
    border: `1px solid #ccc`,
    padding: 15
}

const containerStyle = {
    width: '100%',
    height: '800px'
};

const getIconColor = (item) => {
    if (item.rlz == 3) {
        return { color: colors.green[600] }
    } else if (item.sxc || item.hsv || item.dca || item.dia) {
        return { color: colors.yellow[600] }
    } else {
        return { color: colors.red[600] }
    }
}


const UnitLocation = ({ location, openEdition }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Table stickyHeader size="small" aria-label="a dense table">
                <TableRow>
                    <TableCell align="left"  >
                        <Typography variant='h5' color='secondary'>
                            <b>Centro de Custo:</b>&nbsp;
                            {location.codigo}
                        </Typography>
                    </TableCell>
                    <TableCell align="left"  >
                        <Typography variant='h5' color='secondary'>
                            <b>Nome da Unidade:</b>&nbsp;
                            {location.nome}
                        </Typography>
                    </TableCell>
                </TableRow>

                <TableRow>
                    <TableCell align="left" >
                        <Typography variant='h5' color='secondary'>
                            <b>Tipo de Unidade:</b>&nbsp;
                            {location.tipo}
                        </Typography>
                    </TableCell>
                    <TableCell align="left"  >
                        <Typography variant='h5' color='secondary'>
                            <b>Endereço:</b>&nbsp;
                            {location.endereco}
                        </Typography>
                    </TableCell>
                </TableRow>

                <TableRow>
                    <TableCell align="left" >
                        <Typography variant='h5' color='secondary'>
                            <b>Rota:</b>&nbsp;
                            {location.rota}
                        </Typography>
                    </TableCell>
                    <TableCell align="left"  >
                        <Typography variant='h5' color='secondary'>
                            <b>Equipe:</b>&nbsp;
                            {location.equipe}
                        </Typography>
                    </TableCell>
                </TableRow>

            </Table>

            <TableContainer component={PerfectScrollbar} className={classes.container}>
                <Table stickyHeader size="small"  >
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                Número
                            </TableCell>
                            <TableCell>
                                Categoria
                            </TableCell>
                            <TableCell>
                                Tipo
                            </TableCell>
                            <TableCell width={400} >
                                Descrição
                            </TableCell>
                            <TableCell>
                                Técnico
                            </TableCell>
                            <TableCell>
                                Abertura
                            </TableCell>
                            <TableCell>
                                Atendimento
                            </TableCell>
                            <TableCell>
                                CPA, CPC
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {location.ocorrencias.map((item) => (
                            <TableRow>

                                <TableCell width={40} noWrap={true} >
                                    <Box
                                        alignItems="center"
                                        display="flex"
                                        component={Link}
                                        onClick={() => { openEdition(item) }}
                                    >
                                        <Avatar
                                            className={classes.avatar}
                                        >
                                            {<Icon component={RiAlarmWarningFill} style={getIconColor(item)} ></Icon>}
                                        </Avatar>
                                        &nbsp;{item.numero}
                                    </Box>
                                </TableCell>

                                <TableCell>
                                    {item.categoria}
                                </TableCell>
                                <TableCell >
                                    <Typography
                                        noWrap={true}
                                        variant="body"
                                    >
                                        <b>{item.tpo}</b>
                                    </Typography>
                                </TableCell>
                                <TableCell noWrap={true}>
                                    {item.dsc}
                                </TableCell>
                                <TableCell>
                                    {item.tecnico}
                                </TableCell>
                                <TableCell>
                                    {(item.abr) ? moment(item.abr).format("DD/MM/YYYY") : ""}
                                </TableCell>
                                <TableCell>
                                    {(item.atd) ? moment(item.atd).format("DD/MM/YYYY") : ""}
                                </TableCell>
                                <TableCell>
                                    {(item.cpa) ? moment(item.cpa).format("DD/MM/YYYY") : ""},
                                    <br></br>
                                    {(item.cpc) ? moment(item.cpc).format("DD/MM/YYYY") : ""}
                                </TableCell>
                            </TableRow>
                        ))}

                    </TableBody>

                </Table>
            </TableContainer>

        </Fragment >
    )
}

const REALIZADO_VENCIDO = "/static/images/map/alarme-1-green.gif";
const REALIZADO_EM_DIA = "/static/images/map/banner-1-green.png";
const EXECUTANDO_VENCIDO = "/static/images/map/alarme-1-yellow.gif";
const EXECUTANDO_EM_DIA = "/static/images/map/banner-1-yellow.png"
const SEM_ACAO_VENCIDO = "/static/images/map/alarme-1-red.gif";
const SEM_ACAO_EM_DIA = "/static/images/map/banner-1-red.png";
const SEM_OCORRENCIA = "/static/images/map/banner-1.png";


const isVencida = (ocorrencia) => {
    return moment(ocorrencia.cpa).isBefore(new Date()) || moment(ocorrencia.cpc).isBefore(new Date());
}

const getFileName = (ocorrencia) => {
    if (ocorrencia.rlz == 3) {
        if (isVencida(ocorrencia)) {
            return REALIZADO_VENCIDO;
        } else {
            return REALIZADO_EM_DIA;
        }
    } else if (ocorrencia.sxc || ocorrencia.hsv || ocorrencia.dca || ocorrencia.dia) {
        if (isVencida(ocorrencia)) {
            return EXECUTANDO_VENCIDO;
        } else {
            return EXECUTANDO_EM_DIA;
        }
    } else {
        if (isVencida(ocorrencia)) {
            return SEM_ACAO_VENCIDO;
        } else {
            return SEM_ACAO_EM_DIA;
        }
    }
}

const Trackmap = ({ changeCenter, resultset, openEdition }) => {

    const classes = useStyles();

    const mapRef = useRef(null);

    const [activeMarker, setActiveMarker] = useState(null);

    function handleLoad(map) {
        mapRef.current = map;
    }

    const handleCenterChanged = (event) => {
        if (!mapRef.current)
            return;
        const newPos = mapRef.current.getCenter().toJSON();
        changeCenter(newPos);
    }

    const handleActiveMarker = (marker) => {
        if (marker === activeMarker) {
            return;
        }
        setActiveMarker(marker);
    };

    const getIconName = (location) => {
        var nome = SEM_OCORRENCIA;
        if (location.ocorrencias && location.ocorrencias.length > 0) {
            for (let index = 0; index < location.ocorrencias.length; index++) {
                const element = location.ocorrencias[index];
                var iconname = getFileName(element);
                if (iconname == SEM_ACAO_VENCIDO || iconname == SEM_ACAO_EM_DIA) {
                    return iconname;
                }
            }

            for (let index = 0; index < location.ocorrencias.length; index++) {
                const element = location.ocorrencias[index];
                iconname = getFileName(element);
                if (iconname == EXECUTANDO_VENCIDO || iconname == EXECUTANDO_EM_DIA) {
                    return iconname;
                }
            }

        }
        return nome;
    }

    return (
        <Fragment>

            <LoadScript
                googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
            >
                <GoogleMap
                    onLoad={handleLoad}
                    mapContainerStyle={containerStyle}
                    center={resultset.base}
                    zoom={12}
                    onCenterChanged={handleCenterChanged}
                >

                    {resultset.rows.map((location) => (
                        <Fragment>

                            <Marker
                                key={location.id}
                                icon={getIconName(location)}
                                scale={2}
                                title={numeral(location.codigo).format('0000') + '-' + location.nome}
                                name={location.nome}
                                position={{ lat: location.latitude, lng: location.longitude }}
                                onClick={() => handleActiveMarker(location.id)}
                            >

                                {activeMarker === location.id ? (

                                    <InfoWindow onCloseClick={() => setActiveMarker(null)} options={{ minWidth: '300px' }}>
                                        <UnitLocation
                                            openEdition={openEdition}
                                            location={location}
                                        >
                                        </UnitLocation>
                                    </InfoWindow>
                                ) : ""}

                            </Marker>
                        </Fragment>
                    ))};

                    {resultset.veiculos.map((veiculo) => (
                        <Marker
                            key={veiculo.placa}
                            icon={(veiculo.velocidade == 0) ? "/static/images/map/stopcar.png" : "/static/images/map/runcar.png"}
                            title={'Placa: ' + veiculo.placa}
                            scale={2}
                            name={veiculo.placa}
                            position={{ lat: veiculo.latitude, lng: veiculo.longitude }}
                        >
                        </Marker>
                    ))}

                </GoogleMap>
            </LoadScript>

        </Fragment >
    );
};

export default Trackmap;